import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={8}
      height={14}
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M7.02 6.535h0L1.881 1h0A.608.608 0 00.98 1h0a.692.692 0 00.001.93h0L5.687 7 .98 12.07h0a.692.692 0 00-.001.929h0a.614.614 0 00.452.201.614.614 0 00.45-.2h0L7.02 7.466s0 0 0 0A.684.684 0 007.2 7a.685.685 0 00-.18-.465z"
        fill="#E40046"
        stroke="#E40046"
        strokeWidth={0.7}
      />
    </Svg>
  );
}

export default SvgComponent;
